import BaseModel from "scripts/models/baseModel";
import AuthenticationSyncHoc from "scripts/hoc/authenticationSyncHoc";

class BaseAuthenticationModel extends AuthenticationSyncHoc(BaseModel) {}

export default BaseAuthenticationModel;
